import { render, staticRenderFns } from "./ReliabilityResume.vue?vue&type=template&id=2ea97d71&scoped=true&"
import script from "./ReliabilityResume.vue?vue&type=script&lang=js&"
export * from "./ReliabilityResume.vue?vue&type=script&lang=js&"
import style0 from "./ReliabilityResume.vue?vue&type=style&index=0&id=2ea97d71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea97d71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VIcon,VSpacer,VTooltip})
